const env = {
  name: process.env.VUE_APP_NAME,
  prefix: process.env.VUE_APP_PREFIX,
  project: process.env.VUE_APP_PROJECT,
  url: process.env.BASE_URL,
};
export default env;
